export default __webpack_public_path__ + "static/media/inspection-active.ce5ee200.svg";